export const EmailSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={17} fill="none">
    <path
      fill="#27272E"
      d="M1.5 16.5a1.438 1.438 0 0 1-1.05-.45A1.438 1.438 0 0 1 0 15V2A1.439 1.439 0 0 1 .45.95 1.439 1.439 0 0 1 1.5.5h17A1.538 1.538 0 0 1 20 2v13a1.538 1.538 0 0 1-1.5 1.5h-17ZM10 8.95 1.5 3.375V15h17V3.375L10 8.95Zm0-1.5L18.4 2H1.625L10 7.45Z"
    />
  </svg>
);

export const PhoneSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={17}
    viewBox="0 0 17.975 18"
  >
    <path
      id="phone_in_talk_FILL0_wght400_GRAD0_opsz48"
      d="M22.377,14.788a7.6,7.6,0,0,0-7.34-7.34V5.95a8.773,8.773,0,0,1,3.383.761A9.222,9.222,0,0,1,23.114,11.4a8.773,8.773,0,0,1,.761,3.383Zm-4.219,0a3.338,3.338,0,0,0-1-2.11,3.419,3.419,0,0,0-2.122-.986v-1.5a4.837,4.837,0,0,1,3.183,1.423,4.763,4.763,0,0,1,1.436,3.171Zm4.693,9.162a13.467,13.467,0,0,1-6.054-1.5,20.555,20.555,0,0,1-5.4-3.895,20.555,20.555,0,0,1-3.895-5.4A13.467,13.467,0,0,1,6,7.1,1.108,1.108,0,0,1,7.123,5.975h3.5a.883.883,0,0,1,.612.237,1.1,1.1,0,0,1,.337.637l.674,3.146a1.8,1.8,0,0,1-.012.637.962.962,0,0,1-.262.487l-2.5,2.521A20.727,20.727,0,0,0,12.6,17.684,17.316,17.316,0,0,0,16.535,20.6l2.372-2.447a1.38,1.38,0,0,1,.574-.387,1.154,1.154,0,0,1,.649-.037l2.971.649a1.091,1.091,0,0,1,.874,1.074v3.37a1.108,1.108,0,0,1-1.123,1.123ZM8.721,12.266l2.022-2.047-.574-2.746H7.5a8.593,8.593,0,0,0,.3,2.135,20.123,20.123,0,0,0,.924,2.659Zm9.212,9.062a12.46,12.46,0,0,0,2.222.774,11.716,11.716,0,0,0,2.322.35V19.781l-2.571-.524ZM8.721,12.266ZM17.933,21.329Z"
      transform="translate(-6 -5.95)"
      fill="#27272e"
    />
  </svg>
);
export const UserSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_57" data-name="Group 57" transform="translate(-861 -365)">
      <rect
        id="Rectangle_9"
        data-name="Rectangle 9"
        width="24"
        height="24"
        transform="translate(861 365)"
        fill="none"
        opacity="0.5"
      />
      <path
        id="person_FILL0_wght400_GRAD0_opsz48"
        d="M17.275,17.646A4.17,4.17,0,0,1,12.928,13.3,4.17,4.17,0,0,1,17.275,8.95,4.17,4.17,0,0,1,21.623,13.3a4.17,4.17,0,0,1-4.348,4.348ZM8,26.95V24.225a3.19,3.19,0,0,1,.551-1.884,3.536,3.536,0,0,1,1.42-1.188,21.787,21.787,0,0,1,3.725-1.3,15.057,15.057,0,0,1,3.58-.435,14.423,14.423,0,0,1,3.565.449,24.691,24.691,0,0,1,3.71,1.29A3.5,3.5,0,0,1,26,22.341a3.19,3.19,0,0,1,.551,1.884V26.95Zm1.739-1.739H24.812v-.986a1.588,1.588,0,0,0-.275-.884,1.745,1.745,0,0,0-.681-.623,15.392,15.392,0,0,0-3.391-1.232,15,15,0,0,0-3.188-.333,15.4,15.4,0,0,0-3.217.333,14.722,14.722,0,0,0-3.391,1.232,1.744,1.744,0,0,0-.928,1.507Zm7.536-9.3A2.528,2.528,0,0,0,19.884,13.3a2.609,2.609,0,1,0-5.217,0,2.528,2.528,0,0,0,2.609,2.609ZM17.275,13.3ZM17.275,25.211Z"
        transform="translate(856 359.05)"
        fill="#27272e"
      />
    </g>
  </svg>
);

export const UrlSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="#27272e"
      viewBox="0 0 256 256"
    >
      <path
        fill="#27272e"
        d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM101.63,168h52.74C149,186.34,140,202.87,128,215.89,116,202.87,107,186.34,101.63,168ZM98,152a145.72,145.72,0,0,1,0-48h60a145.72,145.72,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.79a161.79,161.79,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154.37,88H101.63C107,69.66,116,53.13,128,40.11,140,53.13,149,69.66,154.37,88Zm19.84,16h38.46a88.15,88.15,0,0,1,0,48H174.21a161.79,161.79,0,0,0,0-48Zm32.16-16H170.94a142.39,142.39,0,0,0-20.26-45A88.37,88.37,0,0,1,206.37,88ZM105.32,43A142.39,142.39,0,0,0,85.06,88H49.63A88.37,88.37,0,0,1,105.32,43ZM49.63,168H85.06a142.39,142.39,0,0,0,20.26,45A88.37,88.37,0,0,1,49.63,168Zm101.05,45a142.39,142.39,0,0,0,20.26-45h35.43A88.37,88.37,0,0,1,150.68,213Z"
      ></path>
    </svg>
  );
};

export const StoreSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 256 256"
    >
      <path d="M232 96a7.89 7.89 0 0 0-.3-2.2l-14.35-50.2A16.07 16.07 0 0 0 202 32H54a16.07 16.07 0 0 0-15.35 11.6L24.31 93.8A7.89 7.89 0 0 0 24 96v16a40 40 0 0 0 16 32v64a16 16 0 0 0 16 16h144a16 16 0 0 0 16-16v-64a40 40 0 0 0 16-32ZM54 48h148l11.42 40H42.61Zm50 56h48v8a24 24 0 0 1-48 0Zm-16 0v8a24 24 0 0 1-48 0v-8Zm112 104H56v-56.8a40.57 40.57 0 0 0 8 .8 40 40 0 0 0 32-16 40 40 0 0 0 64 0 40 40 0 0 0 32 16 40.57 40.57 0 0 0 8-.8Zm-8-72a24 24 0 0 1-24-24v-8h48v8a24 24 0 0 1-24 24Z" />
    </svg>
  );
};

export const CompanySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 256 256"
    >
      <path
        fill="#27272e"
        d="M240 208h-16V96a16 16 0 0 0-16-16h-64V32a16 16 0 0 0-24.88-13.32L39.12 72A16 16 0 0 0 32 85.34V208H16a8 8 0 0 0 0 16h224a8 8 0 0 0 0-16ZM208 96v112h-64V96ZM48 85.34 128 32v176H48ZM112 112v16a8 8 0 0 1-16 0v-16a8 8 0 1 1 16 0Zm-32 0v16a8 8 0 0 1-16 0v-16a8 8 0 1 1 16 0Zm0 56v16a8 8 0 0 1-16 0v-16a8 8 0 0 1 16 0Zm32 0v16a8 8 0 0 1-16 0v-16a8 8 0 0 1 16 0Z"
      />
    </svg>
  );
};
export const PasswordSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={23} fill="none">
    <path
      fill="#27272E"
      d="M2.19 22.5a1.564 1.564 0 0 1-1.57-1.571V9.562A1.565 1.565 0 0 1 2.19 7.99h1.83V5.476a4.8 4.8 0 0 1 1.453-3.523A4.8 4.8 0 0 1 9 .5a4.8 4.8 0 0 1 3.52 1.454 4.801 4.801 0 0 1 1.453 3.523V7.99h1.836a1.565 1.565 0 0 1 1.571 1.57V20.93a1.566 1.566 0 0 1-1.57 1.57H2.19Zm0-1.571h13.62V9.562H2.19v11.367ZM9 17.262a1.967 1.967 0 0 0 1.427-.576 1.873 1.873 0 0 0 .592-1.386 2.062 2.062 0 0 0-.589-1.427 1.908 1.908 0 0 0-2.855 0 2.062 2.062 0 0 0-.589 1.427 1.87 1.87 0 0 0 .59 1.388A1.968 1.968 0 0 0 9 17.262ZM5.6 7.99h6.81V5.476a3.4 3.4 0 0 0-6.8 0L5.6 7.99Z"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
    <path
      fill="#040707"
      d="M16 1.678 14.389.068 8 6.455 1.611.067 0 1.678l6.389 6.39L0 14.455l1.611 1.611L8 9.678l6.389 6.39L16 14.455 9.611 8.067 16 1.678Z"
    />
  </svg>
);

export const UsersSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Users" transform="translate(-12 -12)">
      <rect
        id="Rectangle_8293"
        data-name="Rectangle 8293"
        width="30"
        height="30"
        transform="translate(12 12)"
        fill="none"
      />
      <path
        id="group_FILL0_wght300_GRAD0_opsz48"
        d="M3.5,26.1V23.967a2.725,2.725,0,0,1,.463-1.558A2.958,2.958,0,0,1,5.24,21.356a23.659,23.659,0,0,1,3.326-1.179,13.379,13.379,0,0,1,3.382-.393,13.09,13.09,0,0,1,3.34.393A23.957,23.957,0,0,1,18.6,21.356a2.958,2.958,0,0,1,1.277,1.053,2.725,2.725,0,0,1,.463,1.558V26.1Zm18.695,0V24.023a4.259,4.259,0,0,0-.7-2.512,5.62,5.62,0,0,0-1.825-1.642,25.271,25.271,0,0,1,2.835.589,10.907,10.907,0,0,1,2.246.842,3.674,3.674,0,0,1,1.291,1.151,2.732,2.732,0,0,1,.477,1.572V26.1ZM11.949,17.539a3.6,3.6,0,0,1-3.733-3.733,3.584,3.584,0,0,1,1.053-2.667A3.657,3.657,0,0,1,11.949,10.1,3.622,3.622,0,0,1,14.6,11.139a3.584,3.584,0,0,1,1.053,2.667,3.6,3.6,0,0,1-3.705,3.733Zm8.842-3.733a3.657,3.657,0,0,1-1.039,2.681,3.584,3.584,0,0,1-2.667,1.053,3.08,3.08,0,0,1-.407-.028,2.851,2.851,0,0,1-.407-.084,4.634,4.634,0,0,0,.9-1.586,6.321,6.321,0,0,0,.309-2.035,5.62,5.62,0,0,0-.323-1.965,6.552,6.552,0,0,0-.884-1.628,2.057,2.057,0,0,1,.393-.084,3.405,3.405,0,0,1,.421-.028,3.557,3.557,0,0,1,3.705,3.705Zm-16,11.032H19.079v-.87a1.529,1.529,0,0,0-.253-.842,1.7,1.7,0,0,0-.73-.618,17.258,17.258,0,0,0-3.116-1.137,13.043,13.043,0,0,0-3.032-.323,13.179,13.179,0,0,0-3.06.323,17.258,17.258,0,0,0-3.116,1.137,1.7,1.7,0,0,0-.73.618,1.529,1.529,0,0,0-.253.842Zm7.13-8.561a2.4,2.4,0,0,0,2.47-2.47,2.363,2.363,0,0,0-.7-1.74,2.4,2.4,0,0,0-1.768-.7,2.4,2.4,0,0,0-2.442,2.442,2.4,2.4,0,0,0,.7,1.768A2.363,2.363,0,0,0,11.921,16.275ZM11.921,24.837ZM11.921,13.805Z"
        transform="translate(11.5 8.9)"
      />
    </g>
  </svg>
);

export const IntegrationsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 30 30"
  >
    <g id="Integrations" transform="translate(-12 -245)">
      <rect
        id="Rectangle_8296"
        data-name="Rectangle 8296"
        width="30"
        height="30"
        transform="translate(12 245)"
        fill="none"
      />
      <path
        id="Connectin"
        d="M6.5,26.5V19.364H9.885V14.851h5.838V11.636H12.338V4.5h8.067v7.136H17.021v3.215h5.838v4.513h3.385V26.5H18.205V19.364H21.59V16.149H11.154v3.215h3.385V26.5Zm7.136-16.162h5.472V5.769H13.636ZM7.769,25.231h5.5V20.662h-5.5Zm11.705,0h5.5V20.662h-5.5ZM16.372,10.338ZM13.269,20.662ZM19.474,20.662Z"
        transform="translate(10.5 244.5)"
      />
    </g>
  </svg>
);

export const SubscriptionSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Subscription" transform="translate(-12 -355)">
      <rect
        id="Rectangle_8298"
        data-name="Rectangle 8298"
        width="30"
        height="30"
        transform="translate(12 355)"
        fill="none"
      />
      <path
        id="currency_exchange_FILL0_wght400_GRAD0_opsz48"
        d="M12,22a9.036,9.036,0,0,1-4.909-1.5,13,13,0,0,1-3.727-3.432v3.114H2V14.727H7.455v1.364H4.341a11.213,11.213,0,0,0,3.307,3.148A7.906,7.906,0,0,0,12,20.636a8.368,8.368,0,0,0,3.352-.682,8.659,8.659,0,0,0,4.6-4.6A8.368,8.368,0,0,0,20.636,12H22a9.708,9.708,0,0,1-.784,3.886,10.077,10.077,0,0,1-5.33,5.33A9.708,9.708,0,0,1,12,22Zm-.659-3.477V17.3a4.234,4.234,0,0,1-1.716-.875,4.759,4.759,0,0,1-1.17-1.648l1.159-.386a2.592,2.592,0,0,0,.966,1.364,2.632,2.632,0,0,0,1.58.5,2.482,2.482,0,0,0,1.511-.443,1.385,1.385,0,0,0,.6-1.17,1.63,1.63,0,0,0-.568-1.261,7.893,7.893,0,0,0-2.091-1.148A6.606,6.606,0,0,1,9.568,11a2.351,2.351,0,0,1-.682-1.773,2.362,2.362,0,0,1,.682-1.7,3.026,3.026,0,0,1,1.818-.864V5.5h1.25V6.659a3.087,3.087,0,0,1,1.5.545,3.234,3.234,0,0,1,1.023,1.25l-1.091.523a2.489,2.489,0,0,0-.841-.955A2.154,2.154,0,0,0,12.045,7.7a2.178,2.178,0,0,0-1.4.409,1.35,1.35,0,0,0-.511,1.114,1.364,1.364,0,0,0,.591,1.159,9.754,9.754,0,0,0,1.909.977,6.337,6.337,0,0,1,2.227,1.386,2.7,2.7,0,0,1,.659,1.886,2.626,2.626,0,0,1-.2,1.045,2.334,2.334,0,0,1-.58.818,2.985,2.985,0,0,1-.92.557,4.557,4.557,0,0,1-1.227.284v1.182ZM2,12a9.708,9.708,0,0,1,.784-3.886,10.077,10.077,0,0,1,5.33-5.33A9.708,9.708,0,0,1,12,2a9.036,9.036,0,0,1,4.909,1.5,13,13,0,0,1,3.727,3.432V3.818H22V9.273H16.545V7.909h3.114a11.257,11.257,0,0,0-3.3-3.148A7.885,7.885,0,0,0,12,3.364a8.368,8.368,0,0,0-3.352.682,8.659,8.659,0,0,0-4.6,4.6A8.368,8.368,0,0,0,3.364,12Z"
        transform="translate(16 358)"
      />
    </g>
  </svg>
);

export const ConfigurationsSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="#000000"
      d="m7.763 20-.474-3.158a7.152 7.152 0 0 1-2.237-1.289l-2.947 1.342L0 13.184l2.658-1.974a5.119 5.119 0 0 1-.079-.592A7.869 7.869 0 0 1 2.553 10a7.587 7.587 0 0 1 .105-1.21L0 6.816l2.105-3.684 2.921 1.316a7.262 7.262 0 0 1 1.079-.737 6.633 6.633 0 0 1 1.158-.526L7.763 0h4.158l.474 3.184c.402.148.793.323 1.171.526.377.198.727.446 1.039.737l3-1.316 2.079 3.684L17 8.763A7.574 7.574 0 0 1 17.105 10c0 .175-.009.368-.026.579-.017.21-.044.43-.079.658l2.684 1.947-2.105 3.711-2.974-1.342a8.963 8.963 0 0 1-1.053.75c-.36.225-.75.398-1.158.513L11.921 20H7.763Zm2.053-7.026A2.966 2.966 0 0 0 12.789 10a2.964 2.964 0 0 0-2.974-2.974A2.965 2.965 0 0 0 6.842 10a2.965 2.965 0 0 0 2.974 2.974Zm0-1.211a1.752 1.752 0 1 1 1.25-.513 1.7 1.7 0 0 1-1.25.513ZM8.71 18.816h2.237l.395-2.947a5.978 5.978 0 0 0 1.566-.632c.5-.295.965-.648 1.382-1.053l2.737 1.184 1.052-1.868-2.421-1.789c.07-.316.127-.61.171-.882.044-.274.066-.551.066-.829a5.646 5.646 0 0 0-.237-1.684L18.105 6.5l-1.052-1.868-2.763 1.184a5.579 5.579 0 0 0-1.342-1.105 4.152 4.152 0 0 0-1.632-.579l-.342-2.947H8.711l-.342 2.947c-.564.1-1.107.296-1.605.579-.51.296-.971.669-1.368 1.105L2.632 4.632 1.579 6.5 4 8.289c-.072.273-.13.55-.171.829a5.877 5.877 0 0 0 0 1.75c.044.28.101.561.171.842L1.579 13.5l1.053 1.868 2.737-1.184c.403.425.868.784 1.381 1.066.51.276 1.054.483 1.618.618l.342 2.948Z"
    />
  </svg>
);

export const CustomRulesSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="#E7D1B7"
      d="m7.763 20-.474-3.158a7.152 7.152 0 0 1-2.237-1.289l-2.947 1.342L0 13.184l2.658-1.974a5.119 5.119 0 0 1-.079-.592A7.869 7.869 0 0 1 2.553 10a7.587 7.587 0 0 1 .105-1.21L0 6.816l2.105-3.684 2.921 1.316a7.262 7.262 0 0 1 1.079-.737 6.633 6.633 0 0 1 1.158-.526L7.763 0h4.158l.474 3.184c.402.148.793.323 1.171.526.377.198.727.446 1.039.737l3-1.316 2.079 3.684L17 8.763A7.574 7.574 0 0 1 17.105 10c0 .175-.009.368-.026.579-.017.21-.044.43-.079.658l2.684 1.947-2.105 3.711-2.974-1.342a8.963 8.963 0 0 1-1.053.75c-.36.225-.75.398-1.158.513L11.921 20H7.763Zm2.053-7.026A2.966 2.966 0 0 0 12.789 10a2.964 2.964 0 0 0-2.974-2.974A2.965 2.965 0 0 0 6.842 10a2.965 2.965 0 0 0 2.974 2.974Zm0-1.211a1.752 1.752 0 1 1 1.25-.513 1.7 1.7 0 0 1-1.25.513ZM8.71 18.816h2.237l.395-2.947a5.978 5.978 0 0 0 1.566-.632c.5-.295.965-.648 1.382-1.053l2.737 1.184 1.052-1.868-2.421-1.789c.07-.316.127-.61.171-.882.044-.274.066-.551.066-.829a5.646 5.646 0 0 0-.237-1.684L18.105 6.5l-1.052-1.868-2.763 1.184a5.579 5.579 0 0 0-1.342-1.105 4.152 4.152 0 0 0-1.632-.579l-.342-2.947H8.711l-.342 2.947c-.564.1-1.107.296-1.605.579-.51.296-.971.669-1.368 1.105L2.632 4.632 1.579 6.5 4 8.289c-.072.273-.13.55-.171.829a5.877 5.877 0 0 0 0 1.75c.044.28.101.561.171.842L1.579 13.5l1.053 1.868 2.737-1.184c.403.425.868.784 1.381 1.066.51.276 1.054.483 1.618.618l.342 2.948Z"
    />
  </svg>
);

export const RoleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Roles" transform="translate(-12 -12)">
      <path
        id="Path_371"
        data-name="Path 371"
        d="M0,0H30V30H0Z"
        transform="translate(12 12)"
        fill="none"
      />
      <path
        id="assignment_ind_FILL0_wght300_GRAD0_opsz48"
        d="M8.5,22.4A1.5,1.5,0,0,1,7,20.9V6.286a1.5,1.5,0,0,1,1.5-1.5h5.337a1.884,1.884,0,0,1,.427-1.632,1.957,1.957,0,0,1,3.083,0,1.884,1.884,0,0,1,.427,1.632h5.337a1.5,1.5,0,0,1,1.5,1.5V20.9a1.5,1.5,0,0,1-1.5,1.5ZM15.808,5.042a.753.753,0,0,0,.777-.777.767.767,0,0,0-.22-.544.782.782,0,0,0-1.114,0,.767.767,0,0,0-.22.544.753.753,0,0,0,.777.777ZM8.166,20.405a12.633,12.633,0,0,1,3.459-2.293,10.083,10.083,0,0,1,4.184-.868,10.083,10.083,0,0,1,4.184.868,12.633,12.633,0,0,1,3.459,2.293V6.286a.355.355,0,0,0-.337-.337H8.5a.355.355,0,0,0-.337.337Zm7.668-5.363A3.317,3.317,0,0,0,19.176,11.7a3.317,3.317,0,0,0-3.342-3.342,3.183,3.183,0,0,0-2.358.972,3.248,3.248,0,0,0-.959,2.37,3.248,3.248,0,0,0,.959,2.37,3.183,3.183,0,0,0,2.358.972ZM9.2,21.234H22.415v-.207a10.441,10.441,0,0,0-3.122-1.956,9.393,9.393,0,0,0-3.484-.661,9.592,9.592,0,0,0-3.472.648A10.181,10.181,0,0,0,9.2,21Zm6.658-7.383a2.121,2.121,0,0,1-1.541-.622,2.158,2.158,0,0,1,0-3.057,2.174,2.174,0,0,1,3.057.013,2.142,2.142,0,0,1,0,3.044A2.09,2.09,0,0,1,15.86,13.851ZM15.808,13.177Z"
        transform="translate(11 14.6)"
      />
    </g>
  </svg>
);

export const AddSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none">
    <path
      fill="#fff"
      d="M6.034 14V7.966H0V6.034h6.034V0h1.931v6.034H14v1.931H7.966V14H6.034Z"
    />
  </svg>
);

export const DeleteSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={80} height={80}>
    <path
      fill="#e74032"
      stroke="rgba(0,0,0,0)"
      d="M21.539 79.153a8.6 8.6 0 0 1-8.592-8.469L9.86 23.422H7.221a3.22 3.22 0 1 1 0-6.44h16.894V9.8A8.8 8.8 0 0 1 32.909 1h14.184a8.807 8.807 0 0 1 8.8 8.8v7.181h16.894a3.22 3.22 0 0 1 0 6.44H70.14l-3.087 47.263a8.591 8.591 0 0 1-8.584 8.469Zm-2.164-8.8v.209a2.163 2.163 0 0 0 2.16 2.158h36.93a2.157 2.157 0 0 0 2.152-2.158c0-.07 0-.139.006-.209L63.7 23.422H16.311Zm30.086-53.371V9.8a2.37 2.37 0 0 0-2.368-2.367H32.909a2.368 2.368 0 0 0-2.36 2.367v7.181ZM48.02 62.51a3.215 3.215 0 0 1-3.085-3.341l.859-21.331a3.22 3.22 0 0 1 6.434.261l-.859 21.325a3.222 3.222 0 0 1-3.215 3.092 1.1 1.1 0 0 1-.134-.006Zm-16.173.006a3.221 3.221 0 0 1-3.215-3.086l-.858-21.33a3.22 3.22 0 0 1 6.434-.261l.859 21.331a3.225 3.225 0 0 1-3.085 3.347Z"
      data-name="Union 159"
    />
    <path
      fill="none"
      d="M0 0h80v80H0z"
      data-name="Rectangle 9533"
      opacity={0.5}
    />
  </svg>
);

export const DeleteActionSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={18} fill="none">
    <path
      fill="#000"
      d="M4.457 18a1.981 1.981 0 0 1-1.98-1.951l-.71-10.885H1.16a.742.742 0 1 1 0-1.483h3.89V2.027A2.028 2.028 0 0 1 7.077 0h3.267a2.028 2.028 0 0 1 2.027 2.027v1.654h3.89a.742.742 0 0 1 0 1.483h-.61l-.71 10.885A1.98 1.98 0 0 1 12.963 18H4.457Zm-.5-2.027v.048a.5.5 0 0 0 .5.5h8.506a.5.5 0 0 0 .5-.5v-.048l.707-10.809H3.253l.704 10.809Zm6.93-12.292V2.027a.546.546 0 0 0-.544-.545H7.076a.545.545 0 0 0-.544.545v1.654h4.356Zm-.331 10.486a.742.742 0 0 1-.711-.77l.2-4.913a.742.742 0 0 1 1.482.06l-.2 4.912a.742.742 0 0 1-.74.712l-.031-.001Zm-3.725 0a.742.742 0 0 1-.74-.711l-.2-4.913a.742.742 0 0 1 1.482-.06l.2 4.913a.743.743 0 0 1-.711.771H6.83Z"
      opacity={0.4}
    />
  </svg>
);

export const EditActionSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} fill="none">
    <path
      fill="#000"
      d="M.731 18.569a1.262 1.262 0 0 1-.3-1l.451-3.45c.043-.309.185-.596.404-.818l9.178-9.18.042-.044.044-.041L13.18 1.4a1.387 1.387 0 0 1 1.957 0l2.88 2.88a1.386 1.386 0 0 1 0 1.959l-11.9 11.89a1.43 1.43 0 0 1-.826.408l-3.449.45a1.264 1.264 0 0 1-1.111-.42Zm1.877-4.106-.353 2.7 2.7-.353 8.522-8.522L11.13 5.94l-8.522 8.523Zm12.11-7.418 1.787-1.784-2.347-2.35-1.785 1.79 2.344 2.344Z"
    />
  </svg>
);

export const PermissionDetailsSvg = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.687 8.35802L18.9 4.11902L18.064 3.28302L14.691 6.65602L12.991 4.95602L12.155 5.82202L14.687 8.35802ZM0 20V18.209H14.328V20H0ZM15.522 11.343C14.7765 11.3451 14.038 11.1999 13.3489 10.9156C12.6598 10.6313 12.0337 10.2136 11.5066 9.68644C10.9795 9.15933 10.5618 8.53321 10.2775 7.8441C9.99316 7.15499 9.84789 6.41647 9.85 5.67102C9.84802 4.92566 9.99339 4.18725 10.2777 3.49825C10.5621 2.80926 10.9798 2.18326 11.5069 1.65625C12.034 1.12924 12.6601 0.711617 13.3492 0.427382C14.0382 0.143148 14.7766 -0.00208847 15.522 2.26972e-05C16.2674 -0.00208907 17.006 0.14318 17.6951 0.427477C18.3842 0.711773 19.0103 1.12949 19.5374 1.6566C20.0645 2.18372 20.4823 2.80983 20.7665 3.49895C21.0508 4.18806 21.1961 4.92657 21.194 5.67202C21.1961 6.41747 21.0508 7.15599 20.7665 7.8451C20.4823 8.53421 20.0645 9.16033 19.5374 9.68744C19.0103 10.2146 18.3842 10.6323 17.6951 10.9166C17.006 11.2009 16.2674 11.3451 15.522 11.343ZM0 9.85102V8.06002H7.821C7.91956 8.376 8.03916 8.68502 8.179 8.98502C8.31833 9.28369 8.46767 9.57236 8.627 9.85102H0ZM0 14.926V13.134H12.507C12.794 13.2562 13.0882 13.3608 13.388 13.447C13.6957 13.5364 14.01 13.6013 14.328 13.641V14.925L0 14.926Z"
      fill="#1543CC"
    />
  </svg>
);

export const PermissionDetailsAdminSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.37502 12.6078L13.4004 6.58244L12.2065 5.39765L7.37502 10.2292L4.981 7.83515L3.80798 9.01994L7.37502 12.6078ZM8.62935 17.2672C7.44228 17.2672 6.32419 17.0423 5.27506 16.5923C4.22595 16.1424 3.30946 15.5255 2.52558 14.7416C1.74172 13.9578 1.12483 13.0418 0.674896 11.9938C0.224965 10.9458 0 9.82819 0 8.64112C0 7.44017 0.224965 6.31513 0.674896 5.266C1.12483 4.21689 1.74111 3.30367 2.52375 2.52633C3.30638 1.749 4.22199 1.13361 5.2706 0.680167C6.31922 0.226722 7.43739 0 8.62512 0C9.82674 0 10.9526 0.226417 12.0026 0.67925C13.0527 1.13208 13.9661 1.74665 14.7428 2.52294C15.5196 3.29923 16.1345 4.21209 16.5876 5.26152C17.0407 6.31095 17.2672 7.43694 17.2672 8.6395C17.2672 9.82765 17.0405 10.9462 16.5871 11.9952C16.1336 13.0442 15.5182 13.9602 14.7409 14.7431C13.9636 15.526 13.0509 16.1424 12.0029 16.5923C10.9548 17.0423 9.83031 17.2672 8.62935 17.2672ZM8.62773 15.6169C10.5685 15.6169 12.2166 14.9382 13.572 13.5808C14.9274 12.2234 15.6051 10.5763 15.6051 8.6395C15.6051 6.69868 14.9274 5.05058 13.572 3.69521C12.2166 2.33983 10.5666 1.66215 8.62183 1.66215C6.69099 1.66215 5.04636 2.33983 3.68796 3.69521C2.32957 5.05058 1.65038 6.70065 1.65038 8.6454C1.65038 10.5762 2.32907 12.2209 3.68646 13.5793C5.04385 14.9377 6.69094 15.6169 8.62773 15.6169Z"
      fill="#009049"
    />
  </svg>
);

export const ImageUploadSvg = () => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.951 2.26667H14.2696L12.9461 0.252167C12.895 0.174475 12.8257 0.110799 12.7445 0.066805C12.6632 0.0228108 12.5725 -0.000137815 12.4804 6.22647e-07H6.51961C6.4275 -0.000137815 6.33679 0.0228108 6.25555 0.066805C6.1743 0.110799 6.10504 0.174475 6.05392 0.252167L4.72951 2.26667H2.04902C1.50559 2.26667 0.98441 2.48558 0.600144 2.87523C0.215878 3.26489 0 3.79338 0 4.34445V14.9222C0 15.4733 0.215878 16.0018 0.600144 16.3914C0.98441 16.7811 1.50559 17 2.04902 17H16.951C17.4944 17 18.0156 16.7811 18.3999 16.3914C18.7841 16.0018 19 15.4733 19 14.9222V4.34445C19 3.79338 18.7841 3.26489 18.3999 2.87523C18.0156 2.48558 17.4944 2.26667 16.951 2.26667ZM17.8824 14.9222C17.8824 15.1727 17.7842 15.4129 17.6096 15.59C17.4349 15.7672 17.198 15.8667 16.951 15.8667H2.04902C1.802 15.8667 1.56511 15.7672 1.39044 15.59C1.21577 15.4129 1.11765 15.1727 1.11765 14.9222V4.34445C1.11765 4.09396 1.21577 3.85374 1.39044 3.67662C1.56511 3.4995 1.802 3.4 2.04902 3.4H5.02941C5.12152 3.40014 5.21223 3.37719 5.29347 3.3332C5.37472 3.2892 5.44398 3.22553 5.4951 3.14783L6.81858 1.13333H12.1805L13.5049 3.14783C13.556 3.22553 13.6253 3.2892 13.7065 3.3332C13.7878 3.37719 13.8785 3.40014 13.9706 3.4H16.951C17.198 3.4 17.4349 3.4995 17.6096 3.67662C17.7842 3.85374 17.8824 4.09396 17.8824 4.34445V14.9222ZM9.5 5.28889C8.72633 5.28889 7.97003 5.52153 7.32674 5.95739C6.68345 6.39326 6.18207 7.01277 5.886 7.73758C5.58993 8.46239 5.51246 9.25996 5.6634 10.0294C5.81433 10.7989 6.18689 11.5057 6.73396 12.0604C7.28103 12.6152 7.97804 12.9929 8.73685 13.146C9.49566 13.2991 10.2822 13.2205 10.997 12.9203C11.7118 12.62 12.3227 12.1116 12.7525 11.4593C13.1823 10.807 13.4118 10.0401 13.4118 9.25556C13.4118 8.20353 12.9996 7.19459 12.266 6.4507C11.5324 5.70681 10.5375 5.28889 9.5 5.28889ZM9.5 12.0889C8.94738 12.0889 8.40716 11.9227 7.94767 11.6114C7.48818 11.3001 7.13005 10.8575 6.91857 10.3398C6.70709 9.8221 6.65176 9.25241 6.75957 8.7028C6.86738 8.15319 7.1335 7.64834 7.52426 7.25209C7.91502 6.85584 8.41289 6.58599 8.9549 6.47666C9.4969 6.36734 10.0587 6.42345 10.5693 6.6379C11.0798 6.85235 11.5162 7.2155 11.8232 7.68144C12.1302 8.14738 12.2941 8.69518 12.2941 9.25556C12.2941 10.007 11.9997 10.7277 11.4757 11.259C10.9517 11.7904 10.241 12.0889 9.5 12.0889Z"
      fill="#999999"
    />
  </svg>
);

export const DefaultUserSvg = () => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.5694 34.8895C40.3377 32.4715 37.6294 30.5418 34.6152 29.2219C31.601 27.9021 28.3461 27.2207 25.0556 27.2207C21.765 27.2207 18.5101 27.9021 15.4959 29.2219C12.4817 30.5418 9.77341 32.4715 7.54167 34.8895C7.19711 35.2705 7.00436 35.7647 7 36.2784V44.6117C7.0073 45.1595 7.23002 45.6822 7.61993 46.067C8.00984 46.4517 8.53558 46.6673 9.08333 46.6673H41.0278C41.5803 46.6673 42.1102 46.4478 42.5009 46.0571C42.8916 45.6664 43.1111 45.1365 43.1111 44.584V36.2506C43.1 35.7466 42.9077 35.2634 42.5694 34.8895Z"
      fill="#8B8B8B"
    />
    <path
      d="M25.0543 24.4444C30.4237 24.4444 34.7765 20.0917 34.7765 14.7222C34.7765 9.35279 30.4237 5 25.0543 5C19.6848 5 15.332 9.35279 15.332 14.7222C15.332 20.0917 19.6848 24.4444 25.0543 24.4444Z"
      fill="#8B8B8B"
    />
  </svg>
);

export const ToastSuccessSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none">
      <path
        fill="#fff"
        d="m8.542 14.723 6.98-6.98-1.384-1.371-5.596 5.596L5.77 9.195l-1.358 1.372 4.131 4.156Zm1.453 5.397c-1.375 0-2.67-.26-3.885-.782a10.066 10.066 0 0 1-3.185-2.144 10.073 10.073 0 0 1-2.143-3.182A9.739 9.739 0 0 1 0 10.128c0-1.39.26-2.694.782-3.909a9.95 9.95 0 0 1 2.141-3.173c.907-.9 1.967-1.613 3.182-2.139A9.684 9.684 0 0 1 9.99.12c1.392 0 2.696.262 3.912.786a10.096 10.096 0 0 1 3.174 2.136c.9.899 1.612 1.956 2.137 3.172A9.764 9.764 0 0 1 20 10.126a9.691 9.691 0 0 1-.788 3.887 10.23 10.23 0 0 1-2.138 3.183 9.951 9.951 0 0 1-3.172 2.142 9.798 9.798 0 0 1-3.907.782Zm-.002-1.912c2.248 0 4.157-.786 5.727-2.358 1.57-1.572 2.355-3.48 2.355-5.724 0-2.248-.785-4.156-2.355-5.726-1.57-1.57-3.481-2.355-5.734-2.355-2.236 0-4.141.785-5.714 2.355-1.574 1.57-2.36 3.48-2.36 5.733 0 2.237.786 4.142 2.358 5.715 1.572 1.573 3.48 2.36 5.723 2.36Z"
      />
    </svg>
  );
};

export const ToastErrorSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none">
      <path
        d="M7.12531 15.1784L10.6358 11.668L14.1462 15.1784L15.2688 14.0558L11.7584 10.5454L15.2688 7.03494L14.1462 5.91234L10.6358 9.42279L7.12531 5.91234L6.00271 7.03494L9.51316 10.5454L6.00271 14.0558L7.12531 15.1784ZM10.6376 20.5386C9.2627 20.5386 7.96765 20.278 6.75249 19.7569C5.53734 19.2357 4.4758 18.5212 3.56787 17.6133C2.65995 16.7054 1.94542 15.6444 1.42429 14.4305C0.903147 13.2166 0.642578 11.9222 0.642578 10.5473C0.642578 9.15625 0.903147 7.85315 1.42429 6.63799C1.94542 5.42284 2.65924 4.36509 3.56575 3.46473C4.47223 2.56438 5.53276 1.85159 6.74733 1.32639C7.96189 0.801179 9.25703 0.538574 10.6327 0.538574C12.0245 0.538574 13.3285 0.800824 14.5448 1.32532C15.761 1.84983 16.819 2.56165 17.7186 3.4608C18.6183 4.35995 19.3306 5.41728 19.8554 6.6328C20.3802 7.84832 20.6426 9.15252 20.6426 10.5454C20.6426 11.9216 20.38 13.2172 19.8548 14.4322C19.3296 15.6472 18.6168 16.7081 17.7164 17.6149C16.8161 18.5217 15.7589 19.2357 14.545 19.7569C13.3311 20.278 12.0287 20.5386 10.6376 20.5386ZM10.6358 18.627C12.8837 18.627 14.7927 17.8409 16.3626 16.2687C17.9324 14.6965 18.7174 12.7887 18.7174 10.5454C18.7174 8.29741 17.9324 6.38848 16.3626 4.8186C14.7927 3.24872 12.8815 2.46378 10.6289 2.46378C8.3925 2.46378 6.48759 3.24872 4.91421 4.8186C3.34083 6.38848 2.55415 8.29969 2.55415 10.5522C2.55415 12.7886 3.34025 14.6936 4.91247 16.2669C6.48468 17.8403 8.39245 18.627 10.6358 18.627Z"
        fill="#fff"
      />
    </svg>
  );
};

export const SortSvgTop = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={14} fill="none">
      <path
        fill="#7A828A"
        d="m0 4.99.873.893L4.366 2.39v10.936h1.247V2.39l3.514 3.514L10 5.01 4.99 0 0 4.99Z"
      />
    </svg>
  );
};

export const SortSvgBottom = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={14} fill="none">
      <path
        fill="#7A828A"
        d="m10 8.337-.873-.894-3.493 3.493V0H4.387v10.936L.873 7.422 0 8.316l5.01 5.01L10 8.337Z"
      />
    </svg>
  );
};

export const SyncToolSvg = () => {
  return (
    <svg
      id="Skype"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 32 32"
    >
      <path
        id="skype_1_"
        data-name="skype (1)"
        d="M23.207,14.253c-.008.042-.021-.038,0,0a11.43,11.43,0,0,0,.189-2.059A11.351,11.351,0,0,0,12.036.834a11.427,11.427,0,0,0-2.151.2H9.88a6.721,6.721,0,0,0-9.033,9.2,11.456,11.456,0,0,0-.171,1.958A11.355,11.355,0,0,0,12.036,23.554a11.421,11.421,0,0,0,1.99-.177,6.722,6.722,0,0,0,9.181-9.125Zm-11.125,4.9c-4.036,0-5.842-1.984-5.842-3.471a1.269,1.269,0,0,1,1.339-1.3c1.727,0,1.28,2.48,4.5,2.48,1.65,0,2.561-.9,2.561-1.812,0-.551-.272-1.163-1.358-1.43l-3.59-.9C6.8,12,6.279,10.436,6.279,8.967c0-3.05,2.872-4.2,5.569-4.2,2.485,0,5.413,1.373,5.413,3.2a1.313,1.313,0,0,1-1.455,1.24c-1.474,0-1.2-2.04-4.172-2.04-1.473,0-2.289.667-2.289,1.622s1.164,1.257,2.174,1.487l2.657.59c2.91.648,3.648,2.348,3.648,3.948,0,2.479-1.9,4.33-5.743,4.33Zm0,0"
        transform="translate(4 3.751)"
        fill="#0686c3"
      />
      <rect
        id="Rectangle_1786"
        data-name="Rectangle 1786"
        width="50"
        height="50"
        fill="none"
        opacity="0.5"
      />
    </svg>
  );
};
export const SupportEmailSvg = () => {
  return (
    <svg
      id="Mail"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 32 32"
    >
      <path
        id="Union_60"
        data-name="Union 60"
        d="M4.9,18.8A3.9,3.9,0,0,1,1,14.9V1.916q0-.023,0-.046A3.9,3.9,0,0,1,4.9-2H23.1A3.9,3.9,0,0,1,27,1.855q0,.04,0,.079V14.9a3.9,3.9,0,0,1-3.9,3.9ZM3.6,14.9a1.3,1.3,0,0,0,1.3,1.3H23.1a1.3,1.3,0,0,0,1.3-1.3V4.33l-9.678,6.451a1.3,1.3,0,0,1-1.443,0L3.6,4.329ZM14,8.138,24.254,1.3A1.3,1.3,0,0,0,23.1.6H4.9a1.3,1.3,0,0,0-1.154.7Z"
        transform="translate(2 8)"
        fill="#0b78c2"
      />
      <rect
        id="Rectangle_1784"
        data-name="Rectangle 1784"
        width="32"
        height="32"
        fill="none"
        opacity="0.5"
      />
    </svg>
  );
};
export const SupportPhoneSvg = () => {
  return (
    <svg
      id="Call"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_1220"
        data-name="Group 1220"
        transform="translate(-1326 -8949)"
      >
        <path
          id="Path_85"
          data-name="Path 85"
          d="M18.215,24a3.49,3.49,0,0,0,2.5-.717l2.849-2.849a1.5,1.5,0,0,0,.248-1.725c-.786-1.9-5.851-5.522-7.211-5.694-1.044-.132-3.465,3.012-3.465,3.012a7.872,7.872,0,0,1-5.169-4.934L10.89,8.165a1.232,1.232,0,0,0,.143-1.443C10.452,5.317,6.667,0,4.529,0a1.4,1.4,0,0,0-1,.4L.682,3.255c-1.8,1.8.005,10.064,4.959,15.018C9.577,22.208,14.918,24,18.215,24M2.021,4.566,4.655,1.932A15.293,15.293,0,0,1,9.2,7.211l-2.8,2.8a1.324,1.324,0,0,0-.328,1.334,10.042,10.042,0,0,0,6.9,6.582C14.323,18.3,16.808,15,16.808,15c1.286.62,4.7,3.233,5.227,4.31,0,0-3.07,2.817-3.819,2.817A17.783,17.783,0,0,1,6.967,16.948C2.2,12.18,1.446,5.455,2.021,4.566Z"
          transform="translate(1330 8953)"
          fill="#0b78c2"
        />
      </g>
      <rect
        id="Rectangle_1785"
        data-name="Rectangle 1785"
        width="32"
        height="32"
        fill="none"
        opacity="0.5"
      />
    </svg>
  );
};

export const OpenNewTab = () => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4698 0.0698242H8.37892C8.02755 0.0698242 7.74263 0.351669 7.74263 0.699243C7.74263 1.04682 8.02755 1.32866 8.37892 1.32866H11.9336L5.38368 7.80786C5.13513 8.05373 5.13513 8.45215 5.38368 8.69802C5.50782 8.82082 5.67079 8.88249 5.83349 8.88249C5.99618 8.88249 6.15915 8.82109 6.28356 8.69802L12.8335 2.21883V5.73513C12.8335 6.0827 13.1184 6.36455 13.4698 6.36455C13.8211 6.36455 14.1061 6.0827 14.1061 5.73513V0.699243C14.1061 0.351669 13.8211 0.0698242 13.4698 0.0698242Z"
      fill="#0b78c2"
    />
    <path
      d="M10.9237 6.36467C10.5724 6.36467 10.2875 6.64652 10.2875 6.99409V12.6597H1.37805V3.84673H7.10547C7.45684 3.84673 7.74176 3.56488 7.74176 3.21731C7.74176 2.86974 7.45684 2.58789 7.10547 2.58789H0.741758C0.390391 2.58789 0.105469 2.86974 0.105469 3.21731V13.2891C0.105469 13.6367 0.390391 13.9185 0.741758 13.9185H10.9235C11.2748 13.9185 11.5598 13.6367 11.5598 13.2891V6.99409C11.5598 6.64652 11.2748 6.36467 10.9235 6.36467H10.9237Z"
      fill="#0b78c2"
    />
  </svg>
);

export const BlueAddSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={13} fill="none">
    <path
      fill="#153FCD"
      d="M5.172 12.567V7.395H0V5.74h5.172V.567h1.655V5.74H12v1.656H6.828v5.172H5.172Z"
    />
  </svg>
);

export const TickMark = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    viewBox="0 0 33 33"
  >
    <path
      fill="#009049"
      d="m5.986 18.596 1.618-1.617 4.672 4.672L25.04 8.893l1.617 1.617-14.382 14.383-6.29-6.297Z"
    />
  </svg>
);

export const Designation = () => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="idcard"
    width="20px"
    height="20px"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"></path>
  </svg>
);

export const Country = () => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="23px"
    style={{ marginLeft: "-3px" }}
    height="23px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M20.972 11.291a9 9 0 1 0 -8.322 9.686"></path>
    <path d="M3.6 9h16.8"></path>
    <path d="M3.6 15h8.9"></path>
    <path d="M11.5 3a17 17 0 0 0 0 18"></path>
    <path d="M12.5 3a16.986 16.986 0 0 1 2.578 9.018"></path>
    <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"></path>
    <path d="M19 18v.01"></path>
  </svg>
);

export const Industry = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 32 32"
    height="25"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M 20 5 L 20 10.46875 L 17 12.25 L 17 9.21875 L 15.5 10.15625 L 12 12.25 L 12 9.21875 L 10.5 10.15625 L 5.5 13.15625 L 5 13.4375 L 5 27 L 27 27 L 27 5 Z M 22 7 L 25 7 L 25 25 L 7 25 L 7 14.53125 L 10 12.75 L 10 15.78125 L 11.5 14.84375 L 15 12.75 L 15 15.78125 L 16.5 14.84375 L 21.5 11.84375 L 22 11.5625 Z M 9 17 L 9 19 L 11 19 L 11 17 Z M 13 17 L 13 19 L 15 19 L 15 17 Z M 17 17 L 17 19 L 19 19 L 19 17 Z M 21 17 L 21 19 L 23 19 L 23 17 Z M 9 21 L 9 23 L 11 23 L 11 21 Z M 13 21 L 13 23 L 15 23 L 15 21 Z M 17 21 L 17 23 L 19 23 L 19 21 Z M 21 21 L 21 23 L 23 23 L 23 21 Z"></path>
  </svg>
);

export const Playground = () => (
  <svg
    stroke="none"
    fill="balck"
    opacity={"0.8"}
    strokeWidth="0"
    viewBox="0 0 256 256"
    className="ant-menu-item-icon"
    height="23px"
    width="23px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2,125.73,80,152v54.84l-43.84-24a8,8,0,0,1-4.16-7ZM176,152v54.84l43.84-24a8,8,0,0,0,4.16-7v-50.1ZM124.16,25l-41,22.46h0L128,72l44.86-24.56L131.84,25A8,8,0,0,0,124.16,25Z"
      opacity="0.2"
    ></path>
    <path d="M223.68,66.15,135.68,18a15.94,15.94,0,0,0-15.36,0l-88,48.18a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM168,152v50.09l-32,17.52V132.74l80-43.8v32l-43.84,24A8,8,0,0,0,168,152Zm-84.16-7L40,121v-32l80,43.8v86.87L88,202.09V152A8,8,0,0,0,83.84,145Zm-.7-88.41,41,22.45a8,8,0,0,0,7.68,0l41-22.45,34.48,18.87L128,118.88,48.66,75.44ZM128,32h0l28.2,15.44L128,62.89,99.8,47.45ZM40,139.22l32,17.52v36.59L40,175.82Zm144,54.11V156.74l32-17.52v36.6Z"></path>
  </svg>
);
export const Webhook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M178.16,176H111.32A48,48,0,1,1,25.6,139.19a8,8,0,0,1,12.8,9.61A31.69,31.69,0,0,0,32,168a32,32,0,0,0,64,0,8,8,0,0,1,8-8h74.16a16,16,0,1,1,0,16ZM64,184a16,16,0,0,0,14.08-23.61l35.77-58.14a8,8,0,0,0-2.62-11,32,32,0,1,1,46.1-40.06A8,8,0,1,0,172,44.79a48,48,0,1,0-75.62,55.33L64.44,152c-.15,0-.29,0-.44,0a16,16,0,0,0,0,32Zm128-64a48.18,48.18,0,0,0-18,3.49L142.08,71.6A16,16,0,1,0,128,80l.44,0,35.78,58.15a8,8,0,0,0,11,2.61A32,32,0,1,1,192,200a8,8,0,0,0,0,16,48,48,0,0,0,0-96Z"></path>
  </svg>
);

export const Apikey = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    fill="#0a0a0a"
    viewBox="0 0 256 256"
    transform="scale(1, -1) rotate(225)"
  >
    <path d="M215.15,40.85A78,78,0,0,0,86.2,121.31l-56.1,56.1a13.94,13.94,0,0,0-4.1,9.9V216a14,14,0,0,0,14,14H72a6,6,0,0,0,6-6V206H96a6,6,0,0,0,6-6V182h18a6,6,0,0,0,4.24-1.76l10.45-10.44A77.59,77.59,0,0,0,160,174h.1A78,78,0,0,0,215.15,40.85ZM226,98.16c-1.12,35.16-30.67,63.8-65.88,63.84a65.93,65.93,0,0,1-24.51-4.67,6,6,0,0,0-6.64,1.26L117.51,170H96a6,6,0,0,0-6,6v18H72a6,6,0,0,0-6,6v18H40a2,2,0,0,1-2-2V187.31a2,2,0,0,1,.58-1.41l58.83-58.83a6,6,0,0,0,1.26-6.64A65.61,65.61,0,0,1,94,95.92C94,60.71,122.68,31.16,157.83,30A66,66,0,0,1,226,98.16ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"></path>
  </svg>
);

export const Logs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    enableBackground="new 0 0 64 64"
    viewBox="0 0 64 64"
    id="log-document"
  >
    <path
      d="M56.78,64H7.22c-0.43,0-0.78-0.35-0.78-0.78V0.78C6.44,0.35,6.79,0,7.22,0H42.5c0.43,0,0.78,0.35,0.78,0.78v14.09h13.5
				c0.43,0,0.78,0.35,0.78,0.78v47.57C57.56,63.65,57.21,64,56.78,64z M8,62.44h48V16.43H42.5c-0.43,0-0.78-0.35-0.78-0.78V1.56H8
				V62.44z"
    ></path>
    <path d="M56.78 16.43c-.2 0-.41-.08-.56-.24L41.94 1.32c-.3-.31-.29-.81.02-1.1.31-.3.8-.29 1.1.02l14.28 14.87c.3.31.29.81-.02 1.1C57.17 16.36 56.97 16.43 56.78 16.43zM37.93 13.57H13.95c-.43 0-.78-.35-.78-.78 0-.43.35-.78.78-.78h23.98c.43 0 .78.35.78.78C38.71 13.23 38.36 13.57 37.93 13.57zM50.88 22.8H13.95c-.43 0-.78-.35-.78-.78 0-.43.35-.78.78-.78h36.93c.43 0 .78.35.78.78C51.66 22.45 51.31 22.8 50.88 22.8zM50.88 32.03H13.95c-.43 0-.78-.35-.78-.78 0-.43.35-.78.78-.78h36.93c.43 0 .78.35.78.78C51.66 31.68 51.31 32.03 50.88 32.03z"></path>
    <g>
      <path
        d="M48.46,58.01H15.54c-1.31,0-2.37-1.06-2.37-2.37V39.3c0-1.31,1.06-2.37,2.37-2.37h32.92c1.31,0,2.37,1.06,2.37,2.37
				v16.34C50.83,56.94,49.77,58.01,48.46,58.01z M15.54,38.48c-0.45,0-0.81,0.36-0.81,0.81v16.34c0,0.45,0.36,0.81,0.81,0.81h32.92
				c0.45,0,0.81-0.36,0.81-0.81V39.3c0-0.45-0.36-0.81-0.81-0.81H15.54z"
      ></path>
      <path d="M30.59 52.26c-2.2 0-3.8-1.94-3.8-4.62 0-2.78 1.57-4.73 3.82-4.73 2.5 0 3.8 2.33 3.8 4.63C34.4 50.32 32.83 52.26 30.59 52.26zM30.6 44.47c-1.66 0-2.26 1.71-2.26 3.17 0 1.47.7 3.06 2.24 3.06 1.56 0 2.26-1.58 2.26-3.16C32.84 46.07 32.14 44.47 30.6 44.47zM40.54 52.26c-2.69 0-4.44-1.81-4.44-4.6 0-2.79 1.8-4.59 4.59-4.59.92 0 1.68.15 2.41.47.39.17.57.64.4 1.03-.18.4-.64.57-1.03.4-.36-.16-.88-.34-1.78-.34-1.9 0-3.03 1.13-3.03 3.03 0 1.93 1.05 3.04 2.87 3.04.36 0 .64-.03.85-.06v-1.46h-1.15c-.43 0-.78-.35-.78-.78s.35-.78.78-.78h1.93c.43 0 .78.35.78.78v2.83c0 .3-.17.57-.43.7C41.97 52.2 41.14 52.26 40.54 52.26zM25.39 52.26h-4.18c-.43 0-.78-.35-.78-.78v-8.03c0-.43.35-.78.78-.78.43 0 .78.35.78.78v7.25h3.4c.43 0 .78.35.78.78S25.82 52.26 25.39 52.26z"></path>
    </g>
  </svg>
);

export const ConfigurationSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M149.66,138.34a8,8,0,0,0-11.32,0L120,156.69,99.31,136l18.35-18.34a8,8,0,0,0-11.32-11.32L88,124.69,69.66,106.34a8,8,0,0,0-11.32,11.32L64.69,124,41.37,147.31a32,32,0,0,0,0,45.26l5.38,5.37-28.41,28.4a8,8,0,0,0,11.32,11.32l28.4-28.41,5.37,5.38a32,32,0,0,0,45.26,0L132,191.31l6.34,6.35a8,8,0,0,0,11.32-11.32L131.31,168l18.35-18.34A8,8,0,0,0,149.66,138.34Zm-52.29,65a16,16,0,0,1-22.62,0L52.69,181.25a16,16,0,0,1,0-22.62L76,135.31,120.69,180Zm140.29-185a8,8,0,0,0-11.32,0l-28.4,28.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L124,64.69l-6.34-6.35a8,8,0,0,0-11.32,11.32l80,80a8,8,0,0,0,11.32-11.32L191.31,132l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,28.41-28.4A8,8,0,0,0,237.66,18.34Zm-34.35,79L180,120.69,135.31,76l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,203.31,97.37Z"></path>
  </svg>
);

export const ConnectedAppsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M237.66,18.34a8,8,0,0,0-11.32,0l-52.4,52.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L100,88.69l-6.34-6.35A8,8,0,0,0,82.34,93.66L88.69,100,65.37,123.31a32,32,0,0,0,0,45.26l5.38,5.37-52.41,52.4a8,8,0,0,0,11.32,11.32l52.4-52.41,5.37,5.38a32,32,0,0,0,45.26,0L156,167.31l6.34,6.35a8,8,0,0,0,11.32-11.32L167.31,156l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,52.41-52.4A8,8,0,0,0,237.66,18.34Zm-116.29,161a16,16,0,0,1-22.62,0L76.69,157.25a16,16,0,0,1,0-22.62L100,111.31,144.69,156Zm57.94-57.94L156,144.69,111.31,100l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,179.31,121.37ZM88.57,35A8,8,0,0,1,103.43,29l8,20A8,8,0,0,1,96.57,55ZM24.57,93A8,8,0,0,1,35,88.57l20,8A8,8,0,0,1,49,111.43l-20-8A8,8,0,0,1,24.57,93ZM231.43,163a8,8,0,0,1-10.4,4.46l-20-8A8,8,0,1,1,207,144.57l20,8A8,8,0,0,1,231.43,163Zm-64,58.06A8,8,0,0,1,152.57,227l-8-20A8,8,0,0,1,159.43,201Z"></path>
  </svg>
);

export const IpWhiteListSVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    color="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2L3 6v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-9-4z" />
    <path d="M9 12l2 2l4-4" />
  </svg>
);
